/// <reference types="react-scripts" />
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FileView from "components/fileView";
import { LoadingIcon } from "utils/constant";
import { useToast } from "contexts/ToastContext";
import { useAuth } from "contexts/AuthContext";
import { StatusChip } from "components/StatusChip";
import DocumentViewerModal from "components/DocumentViewer";
import UploadTraningReport from "pages/legalTraningProvision/fragments/uploadTraningReport";
import DistributeToWoreda from "./distributeToWoreda";
import UploadWoredaReport from "./uploadWoredaReport";
import { getDistributedTowerDataByAdminUnit } from "services/legalAwarenessService";
import { useTranslation } from "react-i18next";

function LegalAwarenessZone({ request }: { request: any }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [publicFeedback, setPublicFeedback] = useState(false);
    const [uploadAmend, setUploadAmend] = useState(false);
    const [auditDraft, setAuditDraft] = useState(false);
    const [showDraftHistory, setShowDraftHistory] = useState(false);
    const [edit, setEdit] = useState(false);
    const [formState, setFormState] = useState({ ...request });
    const contextData = useAuth();
    const { showToast } = useToast();
    const [viewTeam, setViewTeam] = useState(false);
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDistributeModalOpen, setIsDistributeModalOpen] = useState(false);
    const [isUploadWoredaReportOpen, setIsUploadWoredaReportOpen] = useState(false);
    const [selectedWoredaForReport, setSelectedWoredaForReport] = useState<any>(null);

    // Fetch distributed tower data for WoredaLDR role
    useEffect(() => {
        if (contextData?.user?.roles?.includes("WoredaLDR")) {
            getDistributedTowerDataByAdminUnit(contextData.user.admin_unit || "")
                .then((data) => {
                    console.log("distributed tower data:", data);
                    if (data && data.length > 0) {
                        setFormState((prev: any) => ({
                            ...prev,
                            distributed_to_woreda: data,
                        }));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching distributed tower data:", error);
                });
        }
    }, [contextData?.user?.roles, contextData?.user?.admin_unit]);

    const handleTargetCloseModal = () => {
        setIsTargetModalOpen(false);
    }
    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleUploadProposalClick = () => {
    }

    const [isRespondBackFormOpen, setIsRespondBackFormOpen] = useState(false);
    const [isDistributeToWoredaOpen, setIsDistributeToWoredaOpen] = useState(false);

    const handleFileChange = (
        file: any,
        fieldName: keyof Pick<
            typeof formState,
            "audit_summary_file"
        >
    ) => {
        setFormState((prev: any) => ({
            ...prev,
            [fieldName]: file,
        }));
    };

    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setFormState((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleRespondBackClick = () => {
        setIsRespondBackFormOpen(!isRespondBackFormOpen);
    }

    const handleForward = async (froward_status: string) => {
    };

    // Helper function for button text
    const getReportButtonText = () => {
        if (formState.report_summary) {
            return t("ReUploadLegalAwarenessReport") || "ReUpload Legal Awareness Report";
        }
        return t("UploadLegalAwarenessReport") || "Upload Legal Awareness Report";
    };

    return (
        <div className="flex-1 bg-gray-100 mx-4 rounded-lg overflow-y-scroll scrollbar-hide">
            <div className="flex flex-col max-w-5xl bg-white rounded-lg shadow-md p-6">
                {/* Header */}
                <div className="flex items-center justify-between pb-4 mb-3">
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => navigate("/legal-awareness-creation-zone")}
                            className="text-gray-600 hover:text-gray-800"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 19l-7-7 7-7"
                                />
                            </svg>
                        </button>
                    </div>
                    <h1 className="text-2xl font-semibold text-gray-800 ml-8">
                        {t("LegalAwarenessForZoneImplementation") || "Legal Awareness For Zone Implementation"}
                    </h1>
                    <div className="ml-auto">
                        <StatusChip status={formState.status} />
                    </div>
                    <div>
                    </div>
                </div>

                {/* Legal Awareness — sent from card (governmental) */}
                <div className="mt-6 mb-8 bg-white border border-gray-200 shadow-sm rounded-xl overflow-hidden">
                    <div className="bg-gradient-to-r from-[#0A1D39] to-[#13294d] px-5 py-3 flex items-center gap-3">
                        <svg className="w-7 h-7 text-amber-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <div>
                            <p className="text-[10px] uppercase tracking-widest text-amber-300 font-semibold">{t("OAG") || "OAG"}</p>
                            <p className="text-white font-semibold text-base">{t("LegalAwareness") || "Legal Awareness"}</p>
                        </div>
                    </div>
                    <div className="p-5 space-y-4">
                        <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-[#9B0505]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <div>
                                <p className="text-[10px] uppercase tracking-wide text-gray-400 font-semibold">{t("SentFrom") || "Sent From"}</p>
                                <p className="text-sm font-semibold text-[#0A1D39]">{formState.admin_unit_name || "—"}</p>
                            </div>
                        </div>

                        {/* Legal awareness file distributed to the zone */}
                        {formState?.documents?.find((document: any) => document.document_type === "distrbuted_zone_awarness") && (
                            <div className="border border-gray-200 rounded-lg p-3">
                                <p className="text-[10px] uppercase tracking-wide text-[#0A1D39] font-semibold mb-2">{t("LegalAwarenessFile") || "Legal Awareness File"}</p>
                                <DocumentViewerModal
                                    documents={formState?.documents.filter((document: any) => document.document_type === "distrbuted_zone_awarness")}
                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                />
                            </div>
                        )}

                        {/* Zone report (once submitted) */}
                        {(formState?.report_summary || formState?.documents?.find((document: any) => document.document_type === "distrbuted_zone_report")) && (
                            <div className="rounded-lg border border-green-200 bg-green-50/60 p-3">
                                <p className="text-[10px] uppercase tracking-wide text-green-700 font-semibold mb-1">{t("ZoneReport") || "Zone Report"}</p>
                                {formState?.report_summary && (
                                    <p className="text-sm text-gray-700 text-justify mb-2">{formState.report_summary}</p>
                                )}
                                {formState?.entry_registr && (
                                    <p className="text-xs text-gray-500">{t("RegisterNumber") || "Register Number"}: <span className="font-medium text-gray-700">{formState.entry_registr}</span></p>
                                )}
                                {formState?.request_letter_ref_no && (
                                    <p className="text-xs text-gray-500 mb-2">{t("RequestLetterNumber") || "Request Letter Number"}: <span className="font-medium text-gray-700">{formState.request_letter_ref_no}</span></p>
                                )}
                                {formState?.documents?.find((document: any) => document.document_type === "distrbuted_zone_report") && (
                                    <DocumentViewerModal
                                        documents={formState?.documents.filter((document: any) => document.document_type === "distrbuted_zone_report")}
                                        baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
                
                {/* Distributed Woredas Section */}
                {(formState?.distrbuted_to_woreda || formState?.distributed_to_woreda) && (formState?.distrbuted_to_woreda || formState?.distributed_to_woreda)?.length > 0 && (
                    <div className="mt-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                            <svg className="w-6 h-6 mr-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                            </svg>
                            {t("DistributedWoredas") || "Distributed Woredas"}
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {(formState?.distrbuted_to_woreda || formState?.distributed_to_woreda)?.map((woreda: any, index: number) => {
                                const submitted = !!woreda.report_summary;
                                const initials = String(woreda.admin_unit_name || "?").trim().charAt(0).toUpperCase();
                                const reportDocs = (woreda.documents || []).filter((doc: any) => (doc.document_type || "").includes("report"));
                                return (
                                <div
                                    key={index}
                                    className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden"
                                >
                                    <div className={`h-1 ${submitted ? "bg-green-500" : "bg-amber-400"}`} />
                                    <div className="p-4">
                                        <div className="flex items-center justify-between mb-3">
                                            <div className="flex items-center gap-2.5">
                                                <div className="w-9 h-9 rounded-full bg-[#0A1D39] text-white flex items-center justify-center text-sm font-bold select-none">
                                                    {initials}
                                                </div>
                                                <div>
                                                    <h4 className="font-semibold text-[#0A1D39] leading-tight">{woreda.admin_unit_name}</h4>
                                                    {woreda.sent_date && (
                                                        <p className="text-[11px] text-gray-400">{t("Sent") || "Sent"}: {String(woreda.sent_date).split("T")[0]}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${submitted ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
                                                <span className={`w-1.5 h-1.5 rounded-full ${submitted ? "bg-green-500" : "bg-amber-500"}`} />
                                                {submitted ? (t("Submitted") || "Submitted") : (t("NotSubmitted") || "Not Submitted")}
                                            </span>
                                        </div>

                                        {submitted ? (
                                            <div className="rounded-lg border border-green-200 bg-green-50/60 p-3">
                                                <div className="flex items-center gap-1.5 mb-2">
                                                    <svg className="w-4 h-4 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    <p className="text-[10px] uppercase tracking-wide text-green-700 font-semibold">{t("WoredaReport") || "Woreda Report"}</p>
                                                </div>
                                                <p className="text-sm text-gray-700 leading-relaxed text-justify">{woreda.report_summary}</p>
                                                {woreda.woreda_prosecutor_name && (
                                                    <p className="text-[11px] text-gray-500 mt-2">{t("ReportedBy") || "Reported by"}: <span className="font-medium text-gray-700">{woreda.woreda_prosecutor_name}</span></p>
                                                )}
                                                {reportDocs.length > 0 && (
                                                    <div className="mt-2">
                                                        <DocumentViewerModal
                                                            documents={reportDocs}
                                                            baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="rounded-lg border border-dashed border-amber-300 bg-amber-50/50 p-3 text-center">
                                                <p className="text-xs text-amber-700">{t("AwaitingWoredaReport") || "Awaiting report from this woreda."}</p>
                                                {contextData?.user?.roles?.includes("WoredaLDR") && (
                                                    <button
                                                        type="button"
                                                        className="mt-2 inline-flex items-center gap-1.5 px-4 py-1.5 text-xs font-semibold text-white bg-[#0A1D39] rounded-lg hover:bg-[#13294d] transition-colors"
                                                        onClick={() => {
                                                            setSelectedWoredaForReport(woreda);
                                                            setIsUploadWoredaReportOpen(true);
                                                        }}
                                                    >
                                                        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                                        </svg>
                                                        {t("UploadReport") || "Upload Report"}
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                
                {/* Hide Distribute to Woreda button for all roles */}
                {false && !formState.report_summary && !contextData?.user?.roles?.includes("WoredaLDR") && (
                    <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                        <button
                            type="button"
                            className="ml-auto px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                            onClick={() => setIsDistributeToWoredaOpen(true)}
                        >
                            {loading ? (
                                <div className="flex items-center justify-center">
                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                </div>
                            ) : (
                                t("DistributeToWoreda") || "Distribute to Woreda"
                            )}
                        </button>
                        <button
                            type="button"
                            className="ml-auto px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                            onClick={() => setIsModalOpen(true)}
                        >
                            {loading ? (
                                <div className="flex items-center justify-center">
                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                </div>
                            ) : (
                                getReportButtonText()
                            )}
                        </button>
                    </div>
                )}

                {/* Zonal actions — ZonalLRD / ZonalLIF: distribute to woredas + upload zonal report (hidden once the zonal report is submitted) */}
                {(contextData?.user?.roles?.includes("ZonalLRD") || contextData?.user?.roles?.includes("ZonalLIF")) && !formState?.report_summary && (
                    <div className="mt-4 flex flex-col sm:flex-row sm:items-center justify-end gap-3">
                        <button
                            type="button"
                            onClick={() => setIsDistributeToWoredaOpen(true)}
                            disabled={loading}
                            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-[#0A1D39] text-[#0A1D39] text-sm font-semibold hover:bg-[#0A1D39] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/30 transition-colors disabled:opacity-50"
                        >
                            {loading ? (
                                <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                            ) : (
                                <>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                                    </svg>
                                    {t("DistributeToWoreda") || "Distribute to Woreda"}
                                </>
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={() => setIsModalOpen(true)}
                            disabled={loading}
                            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50"
                        >
                            {loading ? (
                                <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                            ) : (
                                <>
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                    </svg>
                                    {getReportButtonText()}
                                </>
                            )}
                        </button>
                    </div>
                )}

                <UploadTraningReport
                    request={formState}
                    setLegalResearch={setFormState}
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onUploadProposal={handleUploadProposalClick}
                    type="awareness"
                />
                
                {isDistributeToWoredaOpen && (
                    <DistributeToWoreda
                        setFormState={setFormState}
                        formState={formState}
                        isOpen={isDistributeToWoredaOpen}
                        onClose={() => setIsDistributeToWoredaOpen(false)}
                    />
                )}
                
                {isUploadWoredaReportOpen && selectedWoredaForReport && (
                    <UploadWoredaReport
                        request={formState}
                        setLegalResearch={setFormState}
                        isOpen={isUploadWoredaReportOpen}
                        onClose={() => {
                            setIsUploadWoredaReportOpen(false);
                            setSelectedWoredaForReport(null);
                        }}
                        woredaId={selectedWoredaForReport.id}
                        woredaName={selectedWoredaForReport.admin_unit_name}
                    />
                )}
            </div>
        </div>
    );
}

export default LegalAwarenessZone;